import { cn } from "@/lib/utils"
import { useTranslation } from "react-i18next"

type InputFieldProps = {
  name?: string
  type?: string
  label?: string
  placeholder?: string
  value?: string | number
  onBlur?: any
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onlyRead?: boolean
  required?: boolean
  props?: any
  error?: any
  className?: string
}

export function InputText(props: InputFieldProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn("flex flex-grow flex-col", props.className)}
    >
      {props.label && (
        <label
          htmlFor={props.name}
          className="pb-1 font-semibold flex flex-row gap-1 text-sm md:text-base"
        >
          <span> {props.label}</span>
          {props.required && <span className="text-[#E61515]">*</span>}
        </label>
      )}
      <input
        type={props.type}
        id={props.name}
        name={props.name}
        placeholder={props.placeholder}
        defaultValue={props.value}
        readOnly={props.onlyRead}
        className={`h-10 md:h-12  rounded-md pl-2 border border-[#d9d9d9]`}
        onChange={props.onChange}
        autoComplete="off"
        {...props.props}
      />

      {props.error && (
        <span className={`text-[#E61515] text-xs font-semibold`}>
          {t(props.error?.message)}
        </span>
      )}
    </div>
  )
}
